export default __webpack_public_path__ + "static/media/select-group-from-groups.6e90ed46.png";